import React, { Fragment } from "react";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { injectIntl } from "react-intl";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Grid, Typography, IconButton, TextField, Button, Box, Paper } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import {
  withHistory,
  PublishedComponent,
  FormPanel,
  withModulesManager,
  journalize,
  formatMessage,
  formatDateFromISO,
} from "@openimis/fe-core";

import { PROJECT_ACCREDITED, PROJECT_SUSPENDED } from "../constants";

import { suspendProject, cancelProject } from "../actions";

const styles = (theme) => ({
  tableTitle: theme.table.title,
  page: theme.page,
  paper: theme.paper.paper,
  item: theme.paper.item,
  title: theme.paper.title,
  fullHeight: {
    height: "100%",
  },
  titleBar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 2),
    backgroundColor: "#b7d4d8",
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
  },
  backButton: {
    marginRight: theme.spacing(1),
    color: "#006273",
  },
  titleText: {
    color: "#006273",
    fontWeight: 500,
    fontSize: 23,
  },
});

class ProjectsMasterPanel extends FormPanel {
  constructor(props) {
    super(props);
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSuspend = () => {
    const { edited, suspendProject, updateAttribute } = this.props;
    if (edited && edited[0]?.uuid) {
      suspendProject(edited[0].uuid).then(() => {
        updateAttribute("status", PROJECT_SUSPENDED);
      });
    }
  };
  handleCancel = () => {
    const { edited, cancelProject, updateAttribute } = this.props;
    if (edited && edited[0]?.uuid) {
      cancelProject(edited[0].uuid).then(() => {
        updateAttribute("status", PROJECT_CANCELLED);
      });
    }
  };

  render() {
    const { classes, updateAttribute, readOnly = false, edited, projectUuid } = this.props;
    console.log("Project Status (edited[0].status):", edited?.[0]?.status);
    console.log("Edited:", edited);

    const handleEvent = () => {
      window.location.reload();
    };
    return (
      <Fragment>
        <Paper className={classes.paper}>
          <div className={classes.titleBar}>
            <IconButton className={classes.backButton} onClick={this.goBack} aria-label="back" size="small">
              <ArrowBackIosIcon fontSize="medium" />
            </IconButton>
            <Typography className={classes.titleText} variant="h6">
              {projectUuid ? "Accreditation Details" : "Create Accreditation"}
            </Typography>
          </div>
          <div className={classes.page}>
            <Grid container spacing={2}>
              {edited && edited[0] && (
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label={"Accreditation Name"}
                    value={edited[0]?.projectName ?? ""}
                    disabled={projectUuid}
                    onChange={(e) => updateAttribute("projectName", e.target.value)}
                  />
                </Grid>
              )}
              <Grid item xs={4}>
                <PublishedComponent
                  pubRef="location.HealthFacilityPicker"
                  value={edited[0]?.healthFacility ?? null}
                  readOnly={projectUuid}
                  onChange={(hf) => updateAttribute("healthFacility", hf)}
                  ignoreLocation={true}
                />
              </Grid>
              {projectUuid && (
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    disabled
                    value={
                      edited?.[0]?.status != null
                        ? formatMessage(this.props.intl, "accreditation", `project.status.${edited[0].status}`)
                        : ""
                    }
                    label="Status"
                  />
                </Grid>
              )}
              {projectUuid && (
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    value={
                      !!edited
                        ? formatDateFromISO(this.props.modulesManager, this.props.intl, edited[0]?.createdDate)
                        : ""
                    }
                    label="Date Created"
                    disabled
                  />
                </Grid>
              )}
            </Grid>

            {projectUuid && edited[0]?.status === PROJECT_ACCREDITED && (
              <Box display="flex" justifyContent="end" alignItems="center">
                <Box m={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.handleSuspend();
                      handleEvent();
                    }}
                  >
                    Suspend Hospital
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.handleCancel();
                      handleEvent();
                    }}
                  >
                    Cancel Hospital
                  </Button>
                </Box>
              </Box>
            )}

            <Box display="flex" justifyContent="end" sx={{ m: 2 }}>
              {!projectUuid && (
                <Button variant="contained" color="primary" onClick={this.props.createProject}>
                  Save
                </Button>
              )}
            </Box>
          </div>
        </Paper>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  rights: !!state.core?.user?.i_user?.rights ? state.core.user.i_user.rights : [],
  mutation: state.quality_assurance_and_accreditation.mutation,
  submittingMutation: state.quality_assurance_and_accreditation.submittingMutation,
  suspendingProject: state.quality_assurance_and_accreditation?.suspendingProject ?? false,
  cancellingProject: state.quality_assurance_and_accreditation?.cancellingProject ?? false,
  suspendingProjectError: state.quality_assurance_and_accreditation?.suspendingProjectError ?? null,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      suspendProject,
      cancelProject,
    },
    dispatch,
  );

export default withModulesManager(
  injectIntl(
    withTheme(withStyles(styles)(withHistory(connect(mapStateToProps, mapDispatchToProps)(ProjectsMasterPanel)))),
  ),
);
